import '../phone/register-countries-locale'
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber'
import * as i18nIsoCountries from 'i18n-iso-countries'

export function displayPhoneNumber({
  countryCode,
  number,
}: {
  countryCode?: string
  number: string
}) {
  const phoneUtil = PhoneNumberUtil.getInstance()

  const regionCode = countryCode
    ? (i18nIsoCountries.alpha3ToAlpha2(countryCode) ?? '')
    : ''

  if (!regionCode) {
    return ''
  }

  const parsedNumber = phoneUtil.parse(number, regionCode)

  const formattedNumber = phoneUtil.format(
    parsedNumber,
    PhoneNumberFormat.INTERNATIONAL,
  )

  return formattedNumber?.replace(/ /g, '')
}
